/*global _ */
import config from './config'
import {getErrorMessagesWithKeys} from '~/lib/axios'

import mustache from 'mustache'

const { UsaStates } = require('usa-states/index.js')
export const countries = require('country-list/data.json')
export const states = new UsaStates().states

export const EventBus = window.VueEventBus
export const DataFilter = window.VueDataFilter || {
  add: () => null,
  apply: () => null,
}
const $ = window.jQuery

export const parseNumber = val => (1 * val) || 0

export const getQS = () => {
  let qs = {}
  let search = (window.location.search || '').replace(/^\?/, '') + '&'
  search.replace(/^\?/, '').replace(/([^=]+?)=(.+?)&/g, (f, n, v) => qs[n] = v)
  return qs
}

export const get$ = (selector, p = document) => p.querySelector(selector)

export const style$ = (styles, selector, p = document) => {
  const el = get$(selector, p)
  if (el && el.style) {
    _.forOwn(styles, (value, key) => {
        el.style[key] = value
    })
  }
}

export const html$ = (html, selector, p = document) => {
  const el = get$(selector, p)
  if (el) {
      el.innerHTML = html
  }
}

export const forceUpdateOnResize = (vm, wait = 500, force = true) => {

  const debouncedResize = () => {
    if (vm.setAppWidth) {
      vm.setAppWidth(document.body.offsetWidth)
    }
    if (force) {
      vm.$forceUpdate()
    }
  }

  window.addEventListener('resize', _.debounce(debouncedResize, wait))
}

export const coerceBoolean = (value) => {
  if (_.isBoolean(value)) {
    return value
  }
  const map = {
    'true': true,
    'false': false,
    'yes': true,
    'no': false,
    'on': true,
    'off': false,
  }
  let newValue = map[(''+value).toLowerCase()]
  if (_.isNil(newValue)) {
    newValue = !!(1 * value)
  }
  return newValue
}

export const pushState = (path, state, title) => {
  state = state || history.state || {}
  window.history.pushState(state, title, path)
}

export const formatPrice = (amount, decimals = 2, truncateZeroDecimals = true) => {
  let value = (1 * amount || 0).toFixed(decimals)
  if (truncateZeroDecimals) {
    value = value.replace(/\.0+?$/, '')
  }
  return value
}

export const alert = (message, options) => {
  const config = Object.assign({type: 'modal', block: true, toast: false, containerClass: 're-container'}, options || {})
  return toastAlert(message, config.type, config)
}

export const emit = function(name, ...args) {
  if (name) {
    args = [...(args || []), this]
    EventBus.$emit(name, ...args)
    if (this) {
      if (this.$emit) {
        this.$emit(name, ...args)
      }
      if (this.id) {
        EventBus.$emit(`${name}.${this.id}`, ...args)
      }
    }
  }
}

export const getEmitter = (namePrefix) => {
  return (name, args, vm) => {
    emit.call(vm, `${namePrefix}.${name}`, args)
  }
}

export const registerPromise = (() => {
  let id = 0
  return (name, ...args) => {
    const executor = (resolve, reject) => {
      const initEvent = `promise.${name}.init`
      const doneEvent = `promise.${name}.done.${id}`
      const errorEvent = `promise.${name}.error.${id}`
      EventBus.$once(doneEvent, (...eventArgs) => resolve(eventArgs))
      EventBus.$once(errorEvent, (err) => reject(err))
      EventBus.$emit(initEvent, id, ...args)
    }
    ++id
    return new Promise(executor)
  }
})()

export const handlePromise = async (name, handler, errorHandler)  => {
  const promiseName = `promise.${name}`
  EventBus.$on(`${promiseName}.init`, async (promiseId, ...args) => {
    try {
      const data = await handler(...args)
      EventBus.$emit(`${promiseName}.done.${promiseId}`, data)
    } catch (e) {
      console.error({error: e});
      const all = getErrorMessagesWithKeys(e)
      const error = new Error((errorHandler ? errorHandler(e) : e.message) || 'Unknown error!')
      error.all = all
      error.$e = _.get(e, 'response.data', {})
      error.$$e = e
      EventBus.$emit(`${promiseName}.error.${promiseId}`, error)
    }
  })
}

export const fv = (...args) => {
  for(const v of args) {
    if (v !== undefined && v !== null) {
      return v
    }
  }
  return null
}

export const fs = (...args) => {
  for(const v of args) {
    if (v !== undefined && v !== null && v !== '') {
      return v
    }
  }
  return ''
}

export const fn = (...args) => {
  for(const v of args) {
    if (_.isNumber(v) && !_.isNaN(v)) {
      return v
    }
  }
  return 0
}

export const cloneMerge = (object, path = '', merge = {}) => {
  let newObject = _.cloneDeep(object || {})
  if (path) {
    newObject = _.get(newObject, path, {})
  }
  newObject = _.merge({}, newObject, _.cloneDeep(merge || {}))
  return newObject
}

export const templify = function(template, data, tags, partials = {}) {
  const allData = {this: this || {}, ...data || {}}
  if (_.isArray(template)) {
    return template.map(item => templify.call(this, item, data, tags, partials))
  }
  if (_.isObject(template)) {
    return _.mapValues(template, item => templify.call(this, item, data, tags, partials))
  }
  if (!tags) {
    tags = ['{{', '}}']
    let hasTemplate = /{{[^}]+?}}/.test(template)
    if (hasTemplate) {
      template = mustache.render(_.toString(template), allData, tags)
    }
    tags = ['[[', ']]']
    hasTemplate = /\[\[[^\]]+?\]\]/.test(template)
    if (hasTemplate) {
      template = mustache.render(_.toString(template), allData, tags)
    }
    return template
  }
  return mustache.render(_.toString(template), allData, partials, tags)
}

export const hasThisBracketsTemplate = (template) => {
  return /\[\[this\.[^\]]+?\]\]/.test(template)
}

export const hasThisMustacheTemplate = (template) => {
  return /{{this\.[^}]+?}}/.test(template)
}

export const hasThisTemplate = (template) => {
  return hasThisMustacheTemplate(template) || hasThisBracketsTemplate(template)
}

Vue.prototype.$$trim = function (val, chars = '\u200B') {
  return _.trim(val, chars)
}

Vue.prototype.$$get = function (path, defaultValue, data = {}) {
  return _.get(this, path, _.get(data, path, defaultValue))
}

Vue.prototype.$$attrs = function () {
  return _.omitBy(this.$attrs || {}, value => _.isNil(value))
}

Vue.prototype._ = _

Vue.prototype.$$fv = fv
Vue.prototype.$$fs = fs
Vue.prototype.$$fn = fn
Vue.prototype.$$log = console.log
Vue.prototype.$$clone = cloneMerge
Vue.prototype.$$templify = templify

export default {
  EventBus,
  DataFilter,
  fv,
  fs,
  fn,
  countries,
  states,
  parseNumber,
  getQS,
  get$,
  style$,
  html$,
  coerceBoolean,
  pushState,
  formatPrice,
  alert,
  emit,
  getEmitter,
  registerPromise,
  handlePromise,
  cloneMerge,
  templify,
  hasThisBracketsTemplate,
  hasThisMustacheTemplate,
  hasThisTemplate
}
